export {}

const clickEventPushElements = document.querySelectorAll<HTMLElement>('[data-click-event-push]')


export const datalayerPush = (json: object | string) => {
  const parsedJson = typeof json === "string" ? JSON.parse(json) : json;
  if (!parsedJson) return;
  parsedJson._clear = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(parsedJson);
}

clickEventPushElements.forEach(element => {
  const json = element.dataset.clickEventPush
  if (!json) return

  element.addEventListener("click", () => datalayerPush(json))
})
